import React, { Component } from 'react';

import { Container, Row, Col, Card } from 'reactstrap';
import { Form } from 'react-bootstrap';
import classes from './DeviceMonitorEditorBased.module.css';
import GoogleMapsComponent from '../../Dashboard/Maps/GoogleMapsComponent';
import { withTranslation } from 'react-i18next';
import CommandPanel from './CommandPanel';
import EditorBasedKeypad from '../Machines/EditorBasedKeypad/EditorBasedKeypad';
import editorMachines from '../../../services/api/editor/editorMachines';
import UserUtil from '../../../services/util/userUtil';

class DeviceMonitorEditorBased extends Component {
	state = {
		remoteControl: false,
		selectedSlaveIndex: 0,
		editorMachineDefinitions: [],
		actveKaypadIndex: 1
	};

	constructor(props) {
		super(props);
	}

	render() {
		const { t } = this.props;
		const { machine, products } = this.props;

		if (!machine || !machine.name || !machine.machine) return <></>;
		const vmID = machine.vmID;
		const machineKeyboards = [];
		const masterTabs = [];
		const slaveTabs = [];

		let location =
			(machine.country ? machine.country : '') +
			' ' +
			(machine.city ? machine.city : '') +
			' ' +
			(machine.address ? machine.address : '') +
			' ' +
			(machine.zipcode ? machine.zipcode : '');

		const editorMachineParamValue =
			machine && machine.params.MasterMachine?.length > 0
				? machine.params.MasterMachine[0].parameterValue
				: undefined;

		if (!editorMachineParamValue) return <>Please apply a layout.</>;

		const paramObject = JSON.parse(editorMachineParamValue);
		// Set up master keypad
		const editorMachineId = paramObject.editorMachineId;

		// Add Master tab to the list
		masterTabs.push(
			<div
				key={`masterTab`}
				type="button"
				className="btn btn-secondary"
				style={{
					color: 'white',
					backgroundColor:'rgb(68, 77, 88)',
					borderColor: 'rgb(68, 77, 88)'
				}}				
			>
				Master
			</div>
		);

		machineKeyboards.push(
			<div
				key="masterkeyboard"	
			>
				<EditorBasedKeypad
					prefix=""
					editorMachineId={editorMachineId}
					vmID={vmID}
					products={products}
					style={{
						width: '100%'
					}}
					machineType={machine ? machine.machineType : null}
					remoteControlServiceEnabled={
						machine.remoteControlServiceEnabled === 'Y'
					}
					onRemoteControlSwitched={(remoteControl) => {
						this.setState({ remoteControl });
					}}
					remoteControlEnabled={this.state.remoteControl}
				></EditorBasedKeypad>
			</div>
		);

		// Set up slave keypads
		if (machine.slaves) {
			machine.slaves.forEach((slave, index) => {
				slaveTabs.push(
					<div
						key={`slaveTab-${slave.prefix}`}
						type="button"
						className="btn btn-secondary"
						style={{
							color: this.state.actveKaypadIndex === index + 1 ? 'white' : '',
							backgroundColor:
								this.state.actveKaypadIndex === index + 1
									? 'rgb(68, 77, 88)'
									: '',
							borderColor:
								this.state.actveKaypadIndex === index + 1
									? 'rgb(68, 77, 88)'
									: ''
						}}
						onClick={() => {
							this.setState({ actveKaypadIndex: (index + 1) });
						}}
					>
						{slave.prefix} -{' '}
						{
							this.state.editorMachineDefinitions.find(
								(item) => item.MachineID == slave.editorMachineId
							)?.MachineName
						}
					</div>
				);
			});

			machine.slaves.forEach((slave, index) => {
				machineKeyboards.push(
					<div
						key={slave.prefix}
					>
						<EditorBasedKeypad
							prefix={slave.prefix}
							editorMachineId={slave.editorMachineId}
							vmID={vmID}
							products={products}
							style={{
								width: '100%'
							}}
							remoteControlEnabled={this.state.remoteControl}
						></EditorBasedKeypad>
					</div>
				);
			});
		}

		
		const header = (

				<Col>
					{machine.slaves &&
					machine.slaves.length > 0 &&
					machine.slaves[this.state.selectedSlaveIndex].prefix &&
					machine.slaves[this.state.selectedSlaveIndex].prefix.length > 0 ? (
						<>
							<Row className={classes.HeaderRowSlave}>
								<Col xl="7" lg="12" md="12" xs="12">
									<Row>
										<Col>
											<Col>
												<Col>
													<Form.Label>{t('device.details.name')}</Form.Label>
												</Col>
												<Col className={classes.LabelCol}>
													<Form.Label>{machine.customName}</Form.Label>
												</Col>
											</Col>
											<Col>
												<Col>
													<Form.Label>
														{t('device.details.geoLocation')}
													</Form.Label>
												</Col>
												<Col className={classes.LabelCol}>
													<Form.Label>
														{location && location.length > 3
															? location
															: t('promotionManager.promotionTable.noData')}
													</Form.Label>
												</Col>
											</Col>
										</Col>
										<Col>
											{machine && machine.lat && machine.lng ? (
												<Card className={classes.LocationCard}>
													<div className="chart-wrapper">
														<GoogleMapsComponent
															machines={[machine]}
															monitor="true"
														/>
													</div>
												</Card>
											) : null}
										</Col>
									</Row>
								</Col>

								<Col xl="5" lg="12" md="12" xs="12"></Col>
							</Row>
				
							<Row className={classes.HeaderRow}>
								<Col xl="7" lg="12" md="12" xs="12">
									<CommandPanel machine={machine} />
								</Col>
							</Row>
						</>
					) : (
						<Row style={{ paddingRight: '40px' }}>
							<Col xl="7" lg="12" md="12" xs="12" className={classes.HeaderCol}>
								<Row>
									<Col>
										<Col>
											<Col>
												<Form.Label>{t('device.details.name')}</Form.Label>
											</Col>
											<Col className={classes.LabelCol}>
												<Form.Label>{machine.customName}</Form.Label>
											</Col>
										</Col>
										<Col>
											<Col>
												<Form.Label>
													{t('device.details.geoLocation')}
												</Form.Label>
											</Col>
											<Col className={classes.LabelCol}>
												<Form.Label>
													{location && location.length > 3
														? location
														: t('promotionManager.promotionTable.noData')}
												</Form.Label>
											</Col>
										</Col>
									</Col>
									<Col>
										{machine && machine.lat && machine.lng ? (
											<Card className={classes.LocationCard}>
												<div className="chart-wrapper">
													<GoogleMapsComponent machines={[machine]} monitor />
												</div>
											</Card>
										) : null}
									</Col>
								</Row>

								<CommandPanel machine={machine} monitor="true" />
							</Col>
						</Row>
					)}
				</Col>
		);

		const masterTabGroup = (
					<Col>
						<div style={{ width: 'fit-content' }}>
							<div
								className="btn-toolbar"
								role="toolbar"
								aria-label="Toolbar with button groups"
							>
								<div
									className="btn-group mr-2"
									role="group"
									aria-label="First group"
								>
									{masterTabs}
								</div>
							</div>
							{machineKeyboards[0]}
						</div>
					</Col>
		);

		const slaveTabGroup = slaveTabs.length > 0?(
			<Col>
				<div style={{ width: 'fit-content' }}>
					<div
						className="btn-toolbar"
						role="toolbar"
						aria-label="Toolbar with button groups"	
					>
						<div
							className="btn-group mr-2"
							role="group"
							aria-label="First group"									
						>
							{slaveTabs}
						</div>
					</div>
					{machineKeyboards[this.state.actveKaypadIndex]}
				</div>
			</Col>
		) : null;

		return (
			<Container style={{ maxWidth: '100%' }}>
				{ !this.props.hideHeader && header? header : null }

				<Row style={{ marginTop: '10px' }}>
					{masterTabGroup}
					{slaveTabGroup}
				</Row>
			</Container>
		);
	}
}

export default withTranslation()(DeviceMonitorEditorBased);
